import Cabecalho from "components/Cabecalho"
import Container from "components/Container";
import Estaduais from "components/Estaduais";
import PalavraPresidente from "components/PalavraPresidente";
import Rodape from "components/Rodape";



import { Outlet } from "react-router-dom";

function PaginaBase() {
    return (
        <main style={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none'
        }}>
            <Cabecalho />
            <Container>
                <Outlet />
            </Container>
            <PalavraPresidente />
            <Estaduais />
            <Rodape />
        </main>
    )
}

export default PaginaBase;
